document.addEventListener('click', function(event) {
  const bodyHasLock = document.body.classList.contains('klaviyo-prevent-body-scrolling');
  const htmlHasLock = document.documentElement.classList.contains('klaviyo-prevent-body-scrolling');

  if (bodyHasLock || htmlHasLock) {
    if (!event.target.closest('.klaviyo-form')) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  }
});

(function () {
  const intervalTime = 500; // check every 500ms
  const duration = 5000;    // 5 seconds

  const applyFixes = () => {
    document.querySelectorAll("img").forEach(img => {
      // Add lazy loading if missing
      if (!img.hasAttribute("loading")) {
        img.loading = "lazy";
      }

      // Add alt if missing or empty
      if (!img.hasAttribute("alt") || img.alt.trim() === "") {
        img.alt =
          img.title ||
          img.closest("figure")?.innerText ||
          "Image";
      }
    });
  };

  // Run immediately once
  applyFixes();

  // Keep checking
  const intervalId = setInterval(applyFixes, intervalTime);

  // Stop after duration
  setTimeout(() => {
    clearInterval(intervalId);
  }, duration);
})();